import { render } from "./setPassword.vue?vue&type=template&id=7796f3d8&scoped=true"
import script from "./setPassword.vue?vue&type=script&lang=js"
export * from "./setPassword.vue?vue&type=script&lang=js"

import "./setPassword.vue?vue&type=style&index=0&id=7796f3d8&scoped=true&lang=css"

import exportComponent from "/var/www/html/conference/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7796f3d8"]])

export default __exports__